import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const TransactionListbyVendor = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  //Function for print
  const handlePrint = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    // Convert the PDF to a Blob object
    const pdfBlob = pdf.output("blob");

    // Create a URL for the Blob object
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the URL
    const printWindow = window.open(pdfUrl);

    // Wait for the window to load and then print the PDF
    printWindow.addEventListener("load", () => {
      printWindow.print();
    });
  };

  //Function for download
  const handleDownload = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    pdf.save("document.pdf");
  };

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setSelectReport(event.target.value);
    console.log(event.target.value);
  };

  const paramObject = useParams();
  const apicall = () => {
    axios
      .get(
        `${config.reportsBaseUrl}/reports/transactionlistbyvendor?startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, [startdate, enddate]);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, data) => {
      const reportTotal = Number(data.Amountline);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const columnDefs = [
    { field: "VendorName", rowGroup: true },
    { field: "TransactionDate" },
    { field: "TransactionType" },
    { field: "Transactionnumber" },
    { field: "Name" },
    { field: "Memo" },
    { field: "Account" },
    {
      field: "Amount",
      width: 200,
      enableValue: true,
      suppressMenu: true,
      filter: "agNumberColumnFilter",
      aggFunc: "sum",
      valueGetter: function (params) {
        // Parse the string OpenBalance and return as an integer
        const amount = parseInt(params.data.Amount, 10);
        return isNaN(amount) ? 0 : amount;
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };
  const onGridReady = useCallback((params) => {
    setLoading(true);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/transactionlistbyvendor?startdate=${""}&enddate=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    onGridReady();
  }, [onGridReady]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Transaction List by Vendor </h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Transaction List by Vendor
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 mt-4">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Report period
                </label>
                <div className="col-md-9">
                  <select
                    as="select"
                    className="form-control"
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onInput={(event) => {
                      handleDropdownChange(event);
                      // handleChange(event);
                    }}
                    // onChange={handleChange}
                  >
                    {selectedDate.map((u) => (
                      <option value={u.ID}> {u.Name} </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-sm-8 mt-4">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <button
              type="submit"
              className="btn btn-primary pull-right mb-3 w-25 mt-0"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div>

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center">
                  <h2>SonarPos</h2>
                  <h6 className="fw-bold">Transaction List by Vendor</h6>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <h6>
                      Date: {startdate} - {enddate}
                    </h6>
                  </div>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={data}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                  ></AgGridReact>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionListbyVendor;
